export { TZ, ymd, dowOf, minuteOfDay, fmtMin, fmtTime, hm } from '../../functions/lib/time.js';
export { DAYS, DAY_LABEL, statusAt, intervals, hoursText, parseHoursText, normHours } from '../../functions/lib/hours.js';
export { haversineMiles, hasXY } from '../../functions/lib/geo.js';
export { driversFor, assignRoute } from '../../functions/lib/assign.js';
export { sameAddress } from '../../functions/lib/address.js';
export { resolveOptions, labDefaults, cleanOptions } from '../../functions/lib/options.js';

export const $ = (s, r = document) => r.querySelector(s);
export const $$ = (s, r = document) => [...r.querySelectorAll(s)];

export function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

export function toast(msg, ms = 6000) {
  const t = document.createElement('div');
  t.className = 'toast';
  t.textContent = msg;
  $('#toasts').appendChild(t);
  setTimeout(() => t.remove(), ms);
}

export function ago(ms) {
  if (!ms) return '';
  const s = Math.max(0, Math.round((Date.now() - ms) / 1000));
  if (s < 60) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr ${m % 60} min ago`;
  const d = Math.round(h / 24);
  return `${d} day${d === 1 ? '' : 's'} ago`;
}

export function prettyDate(dateStr, opts = { weekday: 'long', month: 'short', day: 'numeric' }) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, opts);
}

/** Friendly message for a failed callable or Firestore write. */
export function errMsg(e) {
  const code = e?.code || '';
  if (code.includes('permission-denied')) return e.message && !/Missing or insufficient/.test(e.message) ? e.message : "You don't have access to do that.";
  if (code.includes('unauthenticated')) return 'Your sign-in expired. Sign in again.';
  if (code.includes('unavailable')) return e.message || 'No connection. Try again when you have signal.';
  if (code.includes('failed-precondition') || code.includes('invalid-argument')) return e.message;
  // A callable that hasn't been deployed fails before reaching the server and surfaces as "internal".
  if (code.includes('internal')) return "The server didn't answer. If you just updated the app, run \"firebase deploy --only functions\" and try again.";
  return e?.message || 'Something went wrong. Try again.';
}

export function chime() {
  try {
    const c = new (window.AudioContext || window.webkitAudioContext)();
    const o = c.createOscillator(); const g = c.createGain();
    o.connect(g); g.connect(c.destination); o.frequency.value = 880;
    g.gain.setValueAtTime(0.15, c.currentTime); g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + 0.5);
    o.start(); o.stop(c.currentTime + 0.5);
  } catch { /* sound is optional */ }
}

export const lsGet = (k, d = null) => { try { return localStorage.getItem(k) ?? d; } catch { return d; } };
export const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch { /* private mode */ } };

// Watson blue first, then Pilot's indigo and Tailwind 600s for the other drivers.
export const DRIVER_COLORS = ['#0166cc', '#6366f1', '#d97706', '#059669', '#e11d48'];

/** Google Maps links: open the Maps app on phones. */
export function gmapsTo(p) {
  const dest = typeof p.lat === 'number' ? `${p.lat},${p.lng}` : p.address;
  return `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${encodeURIComponent(dest)}`;
}
export function gmapsRoute(points) {
  if (!points.length) return null;
  const l = points.slice(0, 10).map((p) => (typeof p.lat === 'number' ? `${p.lat},${p.lng}` : p.address));
  const dest = l.pop();
  return `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${encodeURIComponent(dest)}${l.length ? `&waypoints=${encodeURIComponent(l.join('|'))}` : ''}`;
}
